/*
 | -------------------------------------------------------------
 |  --> type: section
 |  --> name: Form errors
 | -------------------------------------------------------------
 |
 |  Take care of form error handling
 |
*/

const invalidFields = document.querySelectorAll('[aria-invalid="true"]')

const setErrorFocus = (event) => {
  invalidFields[0].focus()
}

if (invalidFields !== undefined && invalidFields.length) {
  window.addEventListener('DOMContentLoaded', setErrorFocus)
}
